// extracted by mini-css-extract-plugin
module.exports = {"award-item":"AwardItem_award-item__3Bi7X"};